import { Row, Col, Space, Typography, Table, Button, Input, List } from "antd";
import React, { useEffect, useState } from "react";
import "./ContentList.css";
import ColumnChartRechart from "../Chart.js/ColumnChart ";
import MetaList from "./MetaList";

const { Search } = Input; // Import Search component from Ant Design

function ContentList() {
  const [genreData, setGenreData] = useState([]);
  const [artistData, setArtistData] = useState([]);
  const [trackData, setTrackData] = useState([]);

  const [trackSearchTerm, setTrackSearchTerm] = useState(""); // Search term for tracks
  const [artistSearchTerm, setArtistSearchTerm] = useState(""); // Search term for artists

  const pageSize = 5; // Set page size for pagination

  const songColumns = [
    { title: "Title", dataIndex: "title", key: "title" },
    { title: "Artist", dataIndex: "artist", key: "artist" },
    { title: "Genre", dataIndex: "genre", key: "genre" },
  ];

  const artistColumns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Genre", dataIndex: "genre", key: "genre" },
    {
      title: "Number Of Tracks",
      dataIndex: "numberOfTracks",
      key: "numberOfTracks",
    },
  ];

  const fetchTrackData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/admin/getAllTracks`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const formattedData = data.map((item) => ({
        key: item._id, // Important: Add a unique key for each row
        title: item.title,
        artist: item.artistName,
        genre: item.genre?.name || "Unknown",
      }));
      return formattedData;
    } catch (error) {
      console.error("Error fetching track data:", error);
      return [];
    }
  };

  const fetchArtistData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/admin/getArtists`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const formattedData = data.map((item) => ({
        key: item._id, // Important: Add a unique key for each row
        name: item.artistName,
        genre: item.genres.map((genre) => genre.name).join(", "),
        numberOfTracks: item.totalTrackCount,
      }));
      return formattedData;
    } catch (error) {
      console.error("Error fetching artist data:", error);
      return [];
    }
  };

  const fetchGenreData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/admin/getGenreStatic`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const formattedData = data.map((item) => ({
        genre: item.genreName,
        plays: item.totalPlays,
      }));
      return formattedData;
    } catch (error) {
      console.error("Error fetching genre data:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const genreData = await fetchGenreData();
      setGenreData(genreData);

      const artistData = await fetchArtistData();
      setArtistData(artistData);

      const trackData = await fetchTrackData();
      setTrackData(trackData);
    };
    fetchData();
  }, []);

  // Function to handle track search
  const handleTrackSearch = (value) => {
    setTrackSearchTerm(value);
  };

  // Function to handle artist search
  const handleArtistSearch = (value) => {
    setArtistSearchTerm(value);
  };

  // Filtered track data based on search term
  const filteredTrackData = trackData.filter(
    (track) =>
      track.title.toLowerCase().includes(trackSearchTerm.toLowerCase()) ||
      track.artist.toLowerCase().includes(trackSearchTerm.toLowerCase()) ||
      track.genre.toLowerCase().includes(trackSearchTerm.toLowerCase())
  );

  // Filtered artist data based on search term
  const filteredArtistData = artistData.filter(
    (artist) =>
      artist.name.toLowerCase().includes(artistSearchTerm.toLowerCase()) ||
      artist.genre.toLowerCase().includes(artistSearchTerm.toLowerCase())
  );

  return (
    <div>
      <Typography.Title level={3}>Content List</Typography.Title>
      <Space direction="vertical" style={{ display: "flex" }}>
        <Row gutter={16} justify={"space-around"}>
          <Col span={12} style={{ width: "100%" }}>
            <Typography.Title level={4}>Track List</Typography.Title>
            {/* Search Input for Tracks */}
            <Search
              placeholder="Search Tracks"
              onChange={(e) => handleTrackSearch(e.target.value)}
              style={{ marginBottom: 16 }}
            />
            <Table
              columns={songColumns}
              dataSource={filteredTrackData}
              style={{ width: "100%", margin: 0, padding: 0 }}
              className="custom-table"
              pagination={{ pageSize: pageSize }} // Pagination
            />
          </Col>
          <Col span={12} style={{ width: "100%" }}>
            <Typography.Title level={4}>Artist List</Typography.Title>
            {/* Search Input for Artists */}
            <Search
              placeholder="Search Artists"
              onChange={(e) => handleArtistSearch(e.target.value)}
              style={{ marginBottom: 16 }}
            />
            <Table
              columns={artistColumns}
              dataSource={filteredArtistData}
              style={{ width: "100%", margin: 0, padding: 0 }}
              className="custom-table"
              pagination={{ pageSize: pageSize }} // Pagination
            />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col>
            <ColumnChartRechart
              data={genreData}
              xField="genre"
              yField="plays"
              title="Genre"
              height={350}
              width={900}
            />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <MetaList />
          </Col>
        </Row>
      </Space>
    </div>
  );
}

export default ContentList;
